import { Button, Stack, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CropMonitoringFilter from '/@/components/crop-monitoring/filter';
import Dialog from '/@/components/dialog';
import NOLItemList from '/@/components/new-overlay-list/item-list';
import settings from '/@/core/settings';
import useOverlayConfig from '/@/hooks/crop-monitoring/useOverlayConfig';
import { useToggle } from '/@/hooks/toggle/useToggle';
import { _ } from '/@/locale';
import { resetCropMonitoring as resetCropMonitoringAction } from '/@/store/crop-monitoring/actions';
import { setSelectedFeature } from '/@/store/nav/actions';
import { trackEvent } from '/@/store/tracking/actions';
import useIsMobile from '/@/utils/hooks/is-mobile';
import { reverse } from '/@/utils/router';
import CropMonitoringDialog from '/@/views/fields/field-monitoring/components/creation-dialog';

const CustomizedDivider = styled(Divider)`
    margin-left: 0px;
    margin-right: 0px;
`;

const CropMonitoringHeader = ({
    cropMonitorings,
    filterCropMonitorings,
    setFilterCropMonitorings,
    showFilter,
    selected,
    setShowFilter,
    setSelected,
    setOpenSnack,
}) => {
    const [showPopupDelete, setShowPopupDelete] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const overlayConfig = useOverlayConfig();
    const history = useNavigate();
    const dispatch = useDispatch();
    const setSelectedFeatureAction = bindActionCreators(setSelectedFeature, dispatch);
    const { open: dialogOpen, toggle, setClose } = useToggle();
    const resetCropMonitoring = bindActionCreators(resetCropMonitoringAction, dispatch);

    const isMobile = useIsMobile();

    useEffect(() => {
        setFilterCropMonitorings({ ...filterCropMonitorings, search: searchInput });
    }, [searchInput]);

    const resetFilters = () => {
        setFilterCropMonitorings({});
        setSearchInput('');
    };

    const handleInputFilter = (e) => {
        setSearchInput(e.target.value);
    };

    const handleClickNewCropMonitoring = (event) => {
        if (settings.app.theme === 'expertobayer') {
            toggle();
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleCloseCropMonitoring = () => {
        setAnchorEl(null);
    };

    const handleClickCropMonitoring = (e) => {
        // Change redirect to view for e.type crop (corn or soy)
        const view = e.type;
        const data = { view: 'cropMonitoring.CropMonitoringCorn', selectedFeature: 'cropMonitoringCorn', crop: e.type };
        dispatch(trackEvent({ key: 'cropMonitoring.create.start', type: e.type }));
        setSelectedFeatureAction(data);
        resetCropMonitoring();
        history(reverse(data.view));
    };

    const handleDeleteCropMonitorings = () => {
        // selected.map((cropMonitoring) => {
        //     const cropMonitoringForDelete = allCropMonitorings.find((r) => r.id === cropMonitoring);
        //     deleteCropMonitoringAction(cropMonitoringForDelete);
        // });
        setShowFilter(true);
        setShowPopupDelete(false);
        setOpenSnack(true);
        setSelected([]);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Grid container spacing={2} direction='row' justifyContent='space-between' alignItems='center' sx={{ mb: 2 }}>
            <Grid item xs={12} sm={4}>
                <Typography
                    variant='h5'
                    sx={{
                        color: (t) => t.palette.primary.main,
                    }}
                >
                    {_('Seguimiento de cultivo')}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
                <Stack
                    spacing={2}
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems={{ md: 'center' }}
                    justifyContent='end'
                >
                    <TextField
                        value={searchInput}
                        onChange={handleInputFilter}
                        onReset={() => setSearchInput('')}
                        label={_('Buscar por lote, producto o fechas.')}
                        size='small'
                        fullWidth
                    />
                    <Button
                        size={isMobile ? 'medium' : 'large'}
                        sx={{ whiteSpace: 'nowrap', width: '100%' }}
                        variant='contained'
                        onClick={handleClickNewCropMonitoring}
                    >
                        {_('Crear Nuevo Seguimiento')}
                    </Button>
                </Stack>
            </Grid>

            <Grid item xs={12}>
                <CustomizedDivider variant='middle' />
            </Grid>
            {showFilter ? (
                <Grid item xs={12}>
                    <CropMonitoringFilter
                        cropMonitorings={cropMonitorings}
                        onChangeFilters={setFilterCropMonitorings}
                        filters={filterCropMonitorings}
                        resetFilters={resetFilters}
                    />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <Grid container spacing={2} justifyContent='flex-end'>
                        <Grid item xs={12} sm={4} lg={3}>
                            <Button variant='outlined' color='error' onClick={() => setShowPopupDelete(true)}>
                                {_('Eliminar Seguimiento')}
                                {` (${selected.length})`}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseCropMonitoring}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <NOLItemList myRecommendations itemList={overlayConfig} selectItem={handleClickCropMonitoring} />
            </Popover>
            <CropMonitoringDialog open={dialogOpen} setClose={setClose} entry_source='field-detail' />
            <Dialog
                title={`${_('Eliminar')} (${selected.length})`}
                message={`${_('¿Estás seguro que querés eliminar')}${
                    selected.length === 1 ? _(' el seguimiento seleccionado?') : _(' los seguimientos seleccionados?')
                }`}
                visible={showPopupDelete}
                onClose={() => setShowPopupDelete(false)}
                onCancel={() => setShowPopupDelete(false)}
                onAccept={handleDeleteCropMonitorings}
                alignCenter
            />
        </Grid>
    );
};

export default CropMonitoringHeader;
